// i18n国际化
import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./languages/en";
import zh from "./languages/zh";
Vue.use(VueI18n);

function getQueryString(name, defaultvalue) {
  const vars = {};
  window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      if (value && value.split("#").length > 0) {
        vars[key] = decodeURIComponent(value.split("#")[0]);
      } else {
        vars[key] = decodeURIComponent(value);
      }
    }
  );
  return vars[name] || defaultvalue;
}

if (getQueryString("language") == "en-US") {
  localStorage.setItem("_user_data_language", "en-US");
} else if (getQueryString("language") == "zh-CN") {
  localStorage.setItem("_user_data_language", "zh-CN");
}

let defaultLanguage;
if (
  localStorage._user_data_language == null ||
  localStorage._user_data_language == "undefined"
) {
  if (navigator.language.includes("en")) {
    defaultLanguage = "en";
  } else {
    defaultLanguage = "zh";
  }
} else {
  defaultLanguage = localStorage._user_data_language.includes("en")
    ? "en"
    : "zh";
}
let i18n = new VueI18n({
  locale: defaultLanguage,
  messages: {
    en,
    zh,
  },
});

export default i18n;
